export default __webpack_public_path__ + "static/media/start-no.1935fb5d.svg";